import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { ResponseData, Pagination } from "../model/interface.model";

@Injectable({
  providedIn: "root",
})
export class AccountService {
  endpoint: string = environment.endpoint;
  constructor(private http: HttpClient) {}

  getAccountTypeDemo() {
    return this.http.get<ResponseData>(
      this.endpoint + "/account/get_account_types_demo"
    );
  }

  getAccountTypeLive() {
    return this.http.get<ResponseData>(
      this.endpoint + "/account/get_account_types_live"
    );
  }

  getDemoAccounts() {
    return this.http.get<ResponseData>(
      this.endpoint + "/account/demo_accounts"
    );
  }

  getLiveAccounts() {
    return this.http.get<ResponseData>(
      this.endpoint + "/account/live_accounts"
    );
  }

  getLiveAccountsList() {
    return this.http.get<ResponseData>(
      this.endpoint + "/account/live_accounts_list"
    );
  }

  depositManualLocal(request: FormData) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/manual_deposit",
      request
    );
  }

  withdrawManualLocal(request: {
    login: number;
    amount: number;
    bank_detail: string;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/manual_withdraw",
      request
    );
  }

  internalTransfer(request: {
    from_login: number;
    to_login: number;
    amount: number;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/internal_transfer",
      request
    );
  }

  createDemoAccount(request: {
    type: string;
    leverage: number;
    deposit: number;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/create_demo_account",
      request
    );
  }

  createLiveAccount(request: {
    type: string;
    leverage: number;
    deposit: number;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/create_live_account",
      request
    );
  }

  updateTradeAccountName(request: {
    login: number;
    name: string;
    type: string;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/update_account_name",
      request
    );
  }

  updateTradeAccountPassword(request: {
    login: number;
    type: string;
    password: string;
    password_type: number;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/update_account_password",
      request
    );
  }

  updateTradeAccountLeverage(request: {
    login: number;
    type: string;
    leverage: number;
  }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/update_account_leverage",
      request
    );
  }

  getDepositList(pagination: Pagination) {
    let filter = "&filter=" + false;
    if (pagination.filter !== null) {
      filter = "&filter=" + true;

      if (pagination.filter.start_date !== null)
        filter += "&start_date=" + pagination.filter.start_date;

      if (pagination.filter.end_date !== null)
        filter += "&end_date=" + pagination.filter.end_date;

      if (pagination.filter.status !== null)
        filter += "&status=" + pagination.filter.status;

      if (pagination.filter.email !== null)
        filter += "&email=" + pagination.filter.email;

      if (pagination.filter.login !== null)
        filter += "&login=" + pagination.filter.login;

      if (pagination.filter.gateway !== null)
        filter += "&gateway=" + pagination.filter.gateway;

      if (pagination.filter.order_id !== null)
        filter += "&order_id=" + pagination.filter.order_id;

      if (pagination.filter.operation_type !== null)
        filter += "&operation_type=" + pagination.filter.operation_type;
    }
    return this.http.get<ResponseData>(
      this.endpoint +
        "/account/get_deposit_list?current=" +
        pagination.current +
        "&limit=" +
        pagination.limit +
        filter
    );
  }

  getWithdrawList(pagination: Pagination) {
    let filter = "&filter=" + false;
    if (pagination.filter !== null) {
      filter = "&filter=" + true;

      if (pagination.filter.start_date !== null)
        filter += "&start_date=" + pagination.filter.start_date;

      if (pagination.filter.end_date !== null)
        filter += "&end_date=" + pagination.filter.end_date;

      if (pagination.filter.status !== null)
        filter += "&status=" + pagination.filter.status;

      if (pagination.filter.email !== null)
        filter += "&email=" + pagination.filter.email;

      if (pagination.filter.login !== null)
        filter += "&login=" + pagination.filter.login;

      if (pagination.filter.gateway !== null)
        filter += "&gateway=" + pagination.filter.gateway;

      if (pagination.filter.order_id !== null)
        filter += "&order_id=" + pagination.filter.order_id;

      if (pagination.filter.operation_type !== null)
        filter += "&operation_type=" + pagination.filter.operation_type;
    }
    return this.http.get<ResponseData>(
      this.endpoint +
        "/account/get_withdraw_list?current=" +
        pagination.current +
        "&limit=" +
        pagination.limit +
        filter
    );
  }

  getInternalTransferList(pagination: Pagination) {
    return this.http.get<ResponseData>(
      this.endpoint +
        "/account/get_internal_transfer_list?current=" +
        pagination.current +
        "&limit=" +
        pagination.limit
    );
  }

  cancelWithdraw(request: { login: number; order_id: string }) {
    return this.http.post<ResponseData>(
      this.endpoint + "/account/cancel_withdraw",
      request
    );
  }
}
